/**
 * Swatch Simulator for Variant Deep Links
 * This script finds and clicks the variant swatch inputs for deep-linked variants
 */

(function() {
  // Only run on product pages
  if (!window.location.pathname.includes('/products/')) {
    return;
  }

  // Check for variant in URL
  const urlParams = new URLSearchParams(window.location.search);
  const variantId = urlParams.get('variant');

  if (!variantId) {
    return;
  }

  console.log('Swatch Simulator - Found variant ID in URL:', variantId);

  // Function to find and click the swatch for this variant
  function findAndClickSwatch() {
    console.log('Swatch Simulator - Looking for variant swatches');

    // Since we're specifically handling the burgundy variant deep link issue,
    // we'll force a click on the color swatch if it's the wine chiller
    const isWineChiller = window.location.pathname.includes('/products/wine-chiller');
    const isBurgundyVariant = variantId === '45626169229462' || variantId === '43831623581846';

    console.log('Swatch Simulator - Is wine chiller:', isWineChiller, 'Is burgundy variant:', isBurgundyVariant);

    // Method 1: Find the input with value that corresponds to the burgundy color
    if (isWineChiller && isBurgundyVariant) {
      // For the burgundy color, try a few likely color values
      const colorValues = ['Burgundy', 'burgundy', 'Red', 'red', 'Crimson', 'crimson', 'Merlot', 'merlot'];

      for (const colorValue of colorValues) {
        // Look for radio inputs with this color value
        const inputs = document.querySelectorAll(`input[type="radio"][value="${colorValue}"], input[type="radio"][value*="${colorValue}"]`);

        if (inputs.length > 0) {
          console.log(`Swatch Simulator - Found swatch with color ${colorValue}:`, inputs[0]);

          // Simulate both change and click events
          inputs[0].checked = true;

          // Create and dispatch events
          const changeEvent = new Event('change', { bubbles: true });
          inputs[0].dispatchEvent(changeEvent);

          // Also click the label associated with this input for good measure
          const inputId = inputs[0].id;
          if (inputId) {
            const label = document.querySelector(`label[for="${inputId}"]`);
            if (label) {
              console.log('Swatch Simulator - Clicking associated label:', label);
              label.click();
            }
          }

          return true;
        }
      }
    }

    // Method 2: Look for any variant selector inputs
    console.log('Swatch Simulator - Looking for variant selectors');

    // Find all variant selectors in the page
    const variantSelectors = document.querySelectorAll('.hdt-variant-picker input[is-value]');

    if (variantSelectors.length > 0) {
      console.log('Swatch Simulator - Found variant selectors:', variantSelectors);

      // For each selector, try to find an option that is not currently selected
      // This is important because the media only updates when changing to a different option
      variantSelectors.forEach((selector, index) => {
        // Skip the first few iterations on later attempts to try different combinations
        const attemptCount = window.swatchSimulatorAttempts || 0;
        if (attemptCount > 0 && index < attemptCount) {
          return;
        }

        // Get the name of this selector (like "Color" or "Size")
        const selectorName = selector.getAttribute('name');
        console.log(`Swatch Simulator - Checking selector ${selectorName}`);

        // Find all radio inputs for this selector
        const options = document.querySelectorAll(`input[is-value][name="${selectorName}"]`);

        if (options.length > 1) {
          console.log(`Swatch Simulator - Found ${options.length} options for ${selectorName}`);

          // Find the currently selected option
          const selectedOption = Array.from(options).find(option => option.checked);

          if (selectedOption) {
            console.log(`Swatch Simulator - Current selection for ${selectorName}:`, selectedOption.value);

            // Find an option that's not currently selected
            const differentOption = Array.from(options).find(option => option !== selectedOption);

            if (differentOption) {
              console.log(`Swatch Simulator - Clicking different option:`, differentOption.value);

              // Click this option to force a variant change
              differentOption.checked = true;
              const changeEvent = new Event('change', { bubbles: true });
              differentOption.dispatchEvent(changeEvent);

              // Then click the original selected option to go back to the correct variant
              setTimeout(() => {
                console.log(`Swatch Simulator - Clicking original option:`, selectedOption.value);
                selectedOption.checked = true;
                selectedOption.dispatchEvent(new Event('change', { bubbles: true }));
              }, 100);

              return true;
            }
          } else {
            // If no option is selected, select the first one
            console.log(`Swatch Simulator - No selection for ${selectorName}, selecting first option`);
            options[0].checked = true;
            options[0].dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    }

    // Method 3: Force a click on all color/variant options sequentially
    const allInputs = document.querySelectorAll('input[is-value]');
    if (allInputs.length > 0) {
      console.log('Swatch Simulator - Trying sequential clicks on all variant inputs');

      // Get current attempt count
      window.swatchSimulatorAttempts = (window.swatchSimulatorAttempts || 0) + 1;

      // Select a different input on each attempt
      const inputIndex = (window.swatchSimulatorAttempts - 1) % allInputs.length;
      const input = allInputs[inputIndex];

      console.log(`Swatch Simulator - Attempt ${window.swatchSimulatorAttempts}, clicking input ${inputIndex}:`, input.value);

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      // Find and click the corresponding label
      const inputId = input.id;
      if (inputId) {
        const label = document.querySelector(`label[for="${inputId}"]`);
        if (label) {
          label.click();
        }
      }
    }
  }

  // Run when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      // Run multiple times with increasing delays
      [500, 1000, 1500, 2000, 3000].forEach((delay, index) => {
        setTimeout(findAndClickSwatch, delay);
      });
    });
  } else {
    // If DOM is already loaded, start right away with multiple attempts
    [500, 1000, 1500, 2000, 3000].forEach((delay, index) => {
      setTimeout(findAndClickSwatch, delay);
    });
  }

  // Also try after window load
  window.addEventListener('load', () => {
    [500, 1000, 1500, 2000, 3000].forEach((delay, index) => {
      setTimeout(findAndClickSwatch, delay);
    });
  });
})();